(function() {
  'use strict';

  /* ── Reposition switcher into the correct DOM location ── */
  function repositionSwitcher() {
    var el = document.querySelector('[data-case-switcher]');
    if (!el) return false;

    /* Target the desktop product meta (inside .product__details), not mobile */
    var desktopMeta = document.querySelector('.product__details .product__meta');
    if (!desktopMeta) return false;

    /* Place above the Complimentary Monogram field (product__controls-group--text) */
    var monogramBlock = desktopMeta.querySelector('.product__controls-group--text');
    if (monogramBlock) {
      desktopMeta.insertBefore(el, monogramBlock);
    } else {
      /* Fallback: place before the product form */
      var formBlock = desktopMeta.querySelector('.product-form');
      if (formBlock) {
        desktopMeta.insertBefore(el, formBlock);
      } else {
        /* Last resort: after the header */
        var headerBlock = desktopMeta.querySelector('.product__block--product-header');
        if (!headerBlock) return false;
        var nextSib = headerBlock.nextElementSibling;
        if (nextSib) {
          desktopMeta.insertBefore(el, nextSib);
        } else {
          desktopMeta.appendChild(el);
        }
      }
    }

    /* Reveal it */
    el.style.visibility = 'visible';
    el.style.position  = 'relative';
    el.style.height    = 'auto';
    el.style.overflow  = 'visible';

    return true;
  }

  function attemptReposition(tries) {
    if (tries <= 0) return;
    if (!repositionSwitcher()) {
      setTimeout(function() { attemptReposition(tries - 1); }, 100);
    } else {
      initSwitcher();
    }
  }

  /* ── Normalise a product title into a "base name" ── */
  function baseName(title) {
    return title.toLowerCase()
      .replace(/expandable/g, '')
      .replace(/standard/g, '')
      .replace(/front[\s]?pocket[\s]?carry[\-\s]?on/g, '')
      .replace(/large carry[\-\s]?on/g, '')
      .replace(/large check[\-\s]?in/g, '')
      .replace(/carry[\-\s]?on/g, '')
      .replace(/check[\-\s]?in/g, '')
      .replace(/[\s]+/g, ' ')
      .trim();
  }

  /* ── Detect the size slug from a product title ── */
  function sizeSlug(title) {
    var t = title.toLowerCase();
    if (/large carry[\-\s]?on/.test(t))  return 'large-carry-on';
    if (/large check[\-\s]?in/.test(t))  return 'large-check-in';
    if (/front[\s]?pocket[\s]?carry[\-\s]?on/.test(t)) return 'front-pocket-carry-on';
    if (/carry[\-\s]?on/.test(t))        return 'carry-on';
    if (/check[\-\s]?in/.test(t))        return 'check-in';
    return '';
  }

  /* ── Pretty label for a size slug ── */
  function sizeLabel(slug) {
    var map = {
      'carry-on':              'Carry-On',
      'front-pocket-carry-on': 'Front Pocket Carry-On',
      'large-carry-on':        'Large Carry-On',
      'check-in':              'Check-In',
      'large-check-in':        'Large Check-In'
    };
    return map[slug] || slug;
  }

  /* ── Detect type from product title ── */
  function productType(title) {
    return title.toLowerCase().indexOf('expandable') !== -1 ? 'expandable' : 'standard';
  }

  /* ── Preferred size ordering ── */
  var SIZE_ORDER = ['carry-on', 'front-pocket-carry-on', 'large-carry-on', 'check-in', 'large-check-in'];

  /* ── Main init ── */
  function initSwitcher() {
    var el = document.querySelector('[data-case-switcher]');
    if (!el) return;

    var currentType   = el.getAttribute('data-current-type');
    var currentSize   = el.getAttribute('data-current-size');
    var myBaseName    = el.getAttribute('data-base-name') || '';
    var collHandle    = el.getAttribute('data-collection-handle');
    var sizeBtn       = el.querySelector('[data-switcher-size-btn]');
    var sizeMenu      = el.querySelector('[data-switcher-size-menu]');
    var arrow         = el.querySelector('[data-switcher-arrow]');

    /* ── Dropdown toggle ── */
    if (sizeBtn && sizeMenu) {
      sizeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var isOpen = sizeMenu.classList.contains('case-switcher__size-menu--open');
        if (isOpen) {
          sizeMenu.classList.remove('case-switcher__size-menu--open');
          if (arrow) arrow.classList.remove('case-switcher__arrow--open');
        } else {
          sizeMenu.classList.add('case-switcher__size-menu--open');
          if (arrow) arrow.classList.add('case-switcher__arrow--open');
        }
      });

      /* Close on outside click */
      document.addEventListener('click', function(e) {
        if (!el.contains(e.target)) {
          sizeMenu.classList.remove('case-switcher__size-menu--open');
          if (arrow) arrow.classList.remove('case-switcher__arrow--open');
        }
      });
    }

    /* ── Fetch collection products & build dropdown ── */
    if (!collHandle) return;

    fetchAllProducts(collHandle, function(products) {
      /* Filter to siblings: same base name, not b4u, not sets */
      var siblings = products.filter(function(p) {
        var t = p.title.toLowerCase();
        if (t.indexOf('b4u') !== -1) return false;
        if (t.indexOf(' set') !== -1) return false;
        var pBase = baseName(p.title);
        return pBase === myBaseName;
      });

      /* Build maps: { sizeSlug: { standard: url, expandable: url } } */
      var sizeMap = {};
      siblings.forEach(function(p) {
        var slug = sizeSlug(p.title);
        var type = productType(p.title);
        if (!slug) return;
        if (!sizeMap[slug]) sizeMap[slug] = {};
        sizeMap[slug][type] = collectionProductUrl(collHandle, p.handle);
      });

      /* ── Populate dropdown with all sizes for current type ── */
      if (sizeMenu) {
        /* Clear existing items */
        sizeMenu.innerHTML = '';

        /* Sort sizes in preferred order */
        var sortedSlugs = Object.keys(sizeMap).sort(function(a, b) {
          return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b);
        });

        sortedSlugs.forEach(function(slug) {
          var entry = sizeMap[slug];
          var url   = entry[currentType];
          if (!url) return; /* no product for this type+size combo */

          if (slug === currentSize) {
            /* Current size — bold, no link */
            var div = document.createElement('div');
            div.className = 'case-switcher__size-item case-switcher__size-item--active';
            div.setAttribute('data-switcher-size', slug);
            div.textContent = sizeLabel(slug);
            sizeMenu.appendChild(div);
          } else {
            /* Other size — clickable link */
            var a = document.createElement('a');
            a.className = 'case-switcher__size-item';
            a.setAttribute('data-switcher-size', slug);
            a.href = url;
            a.textContent = sizeLabel(slug);
            sizeMenu.appendChild(a);
          }
        });
      }

      /* ── Update type toggle links ── */
      var oppositeType = currentType === 'standard' ? 'expandable' : 'standard';
      var toggleLink   = el.querySelector('a[data-switcher-pill="' + oppositeType + '"]');
      if (toggleLink && sizeMap[currentSize] && sizeMap[currentSize][oppositeType]) {
        toggleLink.href = sizeMap[currentSize][oppositeType];
      }
    });
  }

  /* ── Build collection product URL ── */
  function collectionProductUrl(collHandle, productHandle) {
    var url = '/collections/' + collHandle + '/products/' + productHandle;
    /* Preserve preview_theme_id if present */
    var params = new URLSearchParams(window.location.search);
    var previewId = params.get('preview_theme_id');
    if (previewId) url += '?preview_theme_id=' + previewId;
    return url;
  }

  /* ── Paginated fetch of all collection products ── */
  function fetchAllProducts(collHandle, callback) {
    var all = [];
    function fetchPage(page) {
      var url = '/collections/' + collHandle + '/products.json?limit=250&page=' + page;
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.products && data.products.length > 0) {
            all = all.concat(data.products);
            if (data.products.length === 250) {
              fetchPage(page + 1);
            } else {
              callback(all);
            }
          } else {
            callback(all);
          }
        })
        .catch(function() { callback(all); });
    }
    fetchPage(1);
  }

  /* ── Start ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { attemptReposition(20); });
  } else {
    attemptReposition(20);
  }
})();